module.exports = {
      id: "tail-down-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "images/js_src_vue/common/sprite.61ac148b.svg#tail-down-usage",
      toString: function () {
        return this.url;
      }
    }